import { render, staticRenderFns } from "./PlotList.vue?vue&type=template&id=cbce574e"
import script from "./PlotList.vue?vue&type=script&lang=js"
export * from "./PlotList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbce574e')) {
      api.createRecord('cbce574e', component.options)
    } else {
      api.reload('cbce574e', component.options)
    }
    module.hot.accept("./PlotList.vue?vue&type=template&id=cbce574e", function () {
      api.rerender('cbce574e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/plot/PlotList.vue"
export default component.exports